import { useTypedQuery } from "hooks";
import { useDMSv3MonitoringDashboardFilters } from "modules/DMSv3/Monitoring/hooks";
import { DMSv3MonitoringDahsboardQueryKeys } from "modules/DMSv3/Monitoring/queryKeys";
import { ApiInstance } from "utils/Api";

export const useWarningsQuery = () => {
  const { data: filters } = useDMSv3MonitoringDashboardFilters();

  const canFetch = Boolean(filters.date_from && filters.date_to) || (!filters.date_from && !filters.date_to);
  const payload = Object.fromEntries(Object.entries(filters).filter(([, value]) => value));

  const { data, isFetching } = useTypedQuery({
    queryKey: DMSv3MonitoringDahsboardQueryKeys.warnings,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, payload, baseUrl)).data,
    refetchOnDependencies: [filters, canFetch],
    enabled: canFetch
  });

  return {
    items: data?.items || [],
    nb_items: data?.nb_items || 0,
    nb_pages: data?.nb_pages || 0,
    isFetching
  };
};
